import { create } from 'zustand'

import apiHandler from 'components/Defaults/ApiHandler'
import axios from 'axios'

export const getUsers = (callback, errorCallback) => {
  const config = {
      url: '/api/admin/users',
      method: "GET"
  }
  apiHandler("Getting Users", config, async config => {
      const response = await axios.request(config);
      callback && callback(response.data)
  }, errorCallback)
}

export const deleteUser = (userId, callback, errorCallback) => {
  const config = {
      url: `/api/admin/users/${userId}`,
      method: "DELETE"
  }
  apiHandler("Deleting User", config, async config => {
      const response = await axios.request(config);
      callback && callback(response.data)
  }, errorCallback)
}

export const adminProtmoteUser = (userId, callback, errorCallback) => {
  const config = {
      url: `/api/admin/users/${userId}/make_admin`,
      method: "POST"
  }
  apiHandler("Promoting User", config, async config => {
      const response = await axios.request(config);
      callback && callback(response.data)
  }, errorCallback)
}

export const adminDemoteUser = (userId, callback, errorCallback) => {
  const config = {
      url: `/api/admin/users/${userId}/remove_admin`,
      method: "POST"
  }
  apiHandler("Demoting User", config, async config => {
      const response = await axios.request(config);
      callback && callback(response.data)
  }, errorCallback)
}

export const updatePasswordUser = (userId, passwordData, callback, errorCallback) => {
  const config = {
      url: `/api/admin/users/${userId}/change_password`,
      method: "POST",
      data: passwordData
  }
  apiHandler("Updating User Password", config, async config => {
      const response = await axios.request(config);
      callback && callback(response.data)
  }, errorCallback)
}

export const useUserStore = create((set, get) => ({
  users: [],
  user_stats: {},
  loading: false,
  error: null,

  setLoading: (loading) => set(() => ({ loading })),
  setError: (error) => set(() => ({ error })),
  setUsers: (users) => set(() => ({ users })),
  setUserStats: (user_stats) => set(() => ({ user_stats })),

  fetchUsers: () => {
    if (get().users.length > 0) return

    getUsers(
      (data) => {
        get().setUsers(data.users)
        get().setUserStats(data.user_stats)
        get().setLoading(false)
        get().setError(null)
      },
      (error) => {
        console.error("Error fetching users:", error)
        get().setLoading(false)
        get().setError("Failed to fetch users")
      }
    );
  },
  deleteUser: (userId) => {
    deleteUser(
      userId,
      () => {
        get().setUsers(get().users.filter(user => user.id !== userId))
      },
      (error) => {
        console.error("Error deleting user:", error)
      }
    )
  },
  adminPromoteUser: (userId) => {
    adminProtmoteUser(
      userId,
      () => {
        get().setUsers(get().users.map(user => user.id === userId ? { ...user, is_admin: true } : user))
      },
      (error) => {
        console.error("Error promoting user:", error)
      }
    )
  },
  adminDemoteUser: (userId) => {
    adminDemoteUser(
      userId,
      () => {
        get().setUsers(get().users.map(user => user.id === userId ? { ...user, is_admin: false } : user))
      },
      (error) => {
        console.error("Error demoting user:", error)
      }
    )
  },
  updatePasswordUser: (userId, passwordData) => {
    updatePasswordUser(
      userId,
      passwordData,
      () => {
        get().setUsers(get().users.map(user => user.id === userId ? { ...user, password: passwordData.password } : user))
      },
      (error) => {
        console.error("Error updating user password:", error)
      }
    )
  }

}))